import store from '@/core/store';

const responseInterceptors = {
  'x-version': value =>
    store.dispatch('headers/setReleaseVersion', Number(value)),
};

export default responseInterceptors;
